import React, { useEffect } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer';
import FeaturesSection from '../components/FeaturesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import Newsletter from '../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faChevronLeft,
  faQuoteRight,
} from "@fortawesome/free-solid-svg-icons";

export default function About() {

  return (
    <>

      <Header />

      <section className="breadcrumbsection">
        <div className='container'>
            <h1>About Grand Indigo</h1>
            <ul className='breadcrumblinks'>
                <li><Link to="/">Home</Link></li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>About Us</li>
            </ul>
        </div>
      </section>


      <section className="about-section">
        <div className="container">
          <div className="row align-items-center mb-5">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="case-study-image">
                <img src="/images/case-study-1.jpg" alt="Custom Uniform Embroidery" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="case-study-content">
                <span className="case-study-tag">More About Grand Indigo</span>
                <h3 className="case-study-title">Transforming Corporate Uniform Identity</h3>
                <p className="case-study-description">
                  We partnered with a leading corporate solutions provider to digitize their entire uniform collection.
                  The project involved creating over 50 unique logo variations for different garment types, ensuring
                  consistent branding across all materials while maintaining exceptional stitch quality and durability.
                </p>
                <p className="case-study-description">
                  We partnered with a leading corporate solutions provider to digitize their entire uniform collection.
                  The project involved creating over 50 unique logo variations for different garment types, ensuring
                  consistent branding across all materials while maintaining exceptional stitch quality and durability.
                </p>
                <a href="/case-studies/corporate-uniform" className="btn btn-primary">Get In Touch</a>
              </div>
            </div>
          </div>

        </div>
      </section>

      <FeaturesSection />

      <TestimonialsSection />

      <Newsletter />

      <Footer />
    </>
  )
}
